<template>
    <div>
        <label>Płeć</label>
        <span v-on:click="handleClick(1)" :class="(gender === 1) ? 'checked' : ''">K</span>
        <span v-on:click="handleClick(0)" :class="(gender === 0) ? 'checked' : ''">M</span>
    </div>
</template>

<script>
    export default {
        name: "gender-picker",
        data: function () {
            return {
                gender: 1
            }
        },
        props: ['val'],
        mounted: function () {
            if(this.val) {
                this.gender = this.val;
            }
        },
        methods: {
            handleClick(value) {
                this.gender = value;
            }
        },
        watch: {
            val: function () {
              this.gender = this.val;
            },
            gender: function () {
                this.$emit('input', this.gender);
            }
        }
    }
</script>

<style scoped lang="scss">

</style>